// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import ResearchCard from "./ResearchCard";

// Sub-Components

// Data / Images / Icons
import { RESEARCH } from "src/data/pages/research";

function ResearchCardGroup() {
  return (
    <div className="flex flex-row gap-6">
      {RESEARCH.map((research) => (
        <ResearchCard key={research.id} research={research} />
      ))}
    </div>
  );
}

export default ResearchCardGroup;
